import React from 'react'

export default function Boot41_ban_text({text}) {
  return (
    <div>
        <div className="ml-4 text-[#4D4D4D] font-montserrat text-[18px] md:text-[20px] leading-normal">
            {text}
          </div>
    </div>
  )
}
